<template>
  <div>
    <div class="quote-wrapper">
      <div v-for="(quote, index) in quotes"
           class="quote"
           :key="index">
        <div v-text='`"${quote.text}"`'
             class="quote__text"/>
        <div class="quote__signature">
          <div v-text="quote.author.name"
               class="signature__name"/>
          <div v-text="quote.author.location"
               class="signature__location"/>
        </div>
      </div>
    </div>
    <div class="quote-wrapper__page-selector">
      <span v-for="(quote, index) in quotes"
            :key="quote.text"
            v-text="index + 1"
            :class="selectedIndex === index ? 'current' : ''"
            class="quote-wrapper__page"
            @click="handlePageSelection"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuotesTabs',
  props: {
    quotes: Array
  },
  data: function () {
    return {
      selectedIndex: 0
    };
  },
  methods: {
    handlePageSelection: function (event) {
      /* eslint-disable */
      const selectedIndex = $(event.target).text() - 1;
      if (this.selectedIndex === selectedIndex) return;
      this.selectedIndex = selectedIndex;
      $(".quote:visible").fadeOut(300, function () {
        $(".quote").eq(selectedIndex).fadeIn();
      });
      /* eslint-enable */
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../styles/setup/variables.scss";
  .quote-wrapper {
    position: relative;
    min-height: 230px;
  }

  .quote {
    display: none;
    &:first-of-type {
      display: block;
    }
  }

  .quote__text {
    padding-left: 4%;
  }

  .quote__signature {
    color: purple;
    padding-top: 40px;

    .signature__name {
      font-weight: 600;
      font-family: $sans-serif;
      font-size: 20px;
      letter-spacing: 3px;
      text-transform: uppercase;
    }
  }

  .quote-wrapper__page-selector {
    padding-top: 20px;

    .quote-wrapper__page {
      margin: 0 5px;
      padding: 0 5px;
      color: $light-blue;
      font-weight: 800;
      cursor: pointer;
      transition: 100ms ease-in-out;
      &:hover {
        color: $purp;
      }

      &.current {
        border-bottom: 3px solid $light-blue;
        &:hover {
          cursor: default;
          color: $light-blue;
        }
      }
    }
  }
</style>
